import { useState } from "react";
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";

import { useAuth } from "../context/AuthContext";
import { usePrescriptionCart } from "../context/pharmacy/PrescriptionCartContext";
import "../styles/dashboard.css";
import {
  Heart,
  MessageSquareText,
  UserKey,
  PackageSearch,
  MapPinCheck,
  Receipt,
  Ambulance,
  UserRoundCheck,
  Award, LogOut
} from "lucide-react";

import ScoreToWalletModal from "./Dashboard/Score/ScoreToWalletModal";

export default function Dashboard() {
  const { user, logout } = useAuth();

  const isConsultant = user?.roles?.includes("Consultant");

  const { items } = usePrescriptionCart();

  const [scoreModalOpen, setScoreModalOpen] = useState(false);

  const [walletAmount, setWalletAmount] = useState(
    Number(user?.wallet_amount || 0)
  );

  const [score, setScore] = useState(
    Number(user?.score || 0)
  );



  return (
    <div className="home-layout">
      <div className="container">
        <aside className="">
          <div className="profile-sidebar">
            <div className="title-user">
              <div className="userInfo">
                <div>
                  <span>
                    {user.name} {user.lname}
                  </span>
                </div>
                <div>
                  <span className="scoreNumber">{user.mobile}</span>
                </div>
              </div>

              <div className="userIntroduced">
                <div>
                  <span>کد معرفی</span>
                </div>
                <div>
                  <span className="scoreNumber">{user.introduced}</span>
                </div>
              </div>

              <div className="userWallet">
                <div>
                  <span>کیف پول</span>
                </div>
                <div>
                  <div className="walletAmount">
                    <span className="walletNumber">
                      {/* {Number(user.wallet_amount).toLocaleString()} */}
                      {walletAmount.toLocaleString()}
                    </span>
                    <span>تومان</span>
                  </div>
                </div>
              </div>

              <div>
                <div>
                  <a>
                    <span>امتیازات</span>
                  </a>
                </div>
                <div>
                  {/* <div className="scorePoint"> */}
                  <div
                    className="scorePoint"
                    onClick={() => setScoreModalOpen(true)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        setScoreModalOpen(true);
                      }
                    }}
                  >
                    <span className="ConvertPoints">
                      <Award color="#fff" strokeWidth={1.5} />
                    </span>

                    <span className="scoreNumber">
                      {" "}
                      {/* {Number(user.score).toLocaleString()} */}
                      {score.toLocaleString()}
                    </span>
                    <span className="pr-2">امتیاز</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="dashboard-links">
              <div>
                <NavLink
                  to="profile"
                  className={({ isActive }) =>
                    isActive ? "sidebar-link active" : "sidebar-link"
                  }
                >
                  <UserRoundCheck size={20} color="#832865" strokeWidth={1} />
                  <p>اطلاعات حساب کاربری</p>
                </NavLink>
              </div>

              <div>
                <NavLink
                  to="/dashboard/orders"
                  className={({ isActive }) =>
                    isActive ? "sidebar-link active" : "sidebar-link"
                  }
                >
                  <Receipt size={20} color="#832865" strokeWidth={1} />
                  <p>سفارش های من</p>
                </NavLink>
              </div>


              {isConsultant && (
                <div>
                  <NavLink
                    to="/dashboard/financial-report"
                    className={({ isActive }) =>
                      isActive ? "sidebar-link active" : "sidebar-link"
                    }
                  >
                    <Receipt size={20} color="#832865" strokeWidth={1} />
                    <p> گزارش مالی </p>
                  </NavLink>
                </div>
              )}



             <div>
                <NavLink to="/dashboard/pharmacy/prescription"
                  className={({ isActive }) =>
                    isActive ? "sidebar-link active" : "sidebar-link"
                  }>
                  <Ambulance size={20} color="#832865" strokeWidth={1} />
                  <p>نسخه های من</p>
                </NavLink>
              </div> 

              <div>
                <NavLink to="address" className={({ isActive }) =>
                  isActive ? "sidebar-link active" : "sidebar-link"
                }>
                  <MapPinCheck size={20} color="#832865" strokeWidth={1} />
                  <p>آدرس های من</p>
                </NavLink>
              </div>

              <div>
                <NavLink to="wishlist" className={({ isActive }) =>
                  isActive ? "sidebar-link active" : "sidebar-link"
                }>
                  <Heart
                    className="icon-heart"
                    fill="none"
                    color="#832865"
                    size={20}
                    strokeWidth={1}
                  />
                  <p> علاقه مندی ها </p>
                </NavLink>
              </div>

              <div>
                <NavLink to="visited-products" className={({ isActive }) =>
                  isActive ? "sidebar-link active" : "sidebar-link"
                }>
                  <PackageSearch size={20} color="#832865" strokeWidth={1} />
                  <p>بازدیدهای من</p>
                </NavLink>
              </div>

              <div>
                <NavLink to="comments" className={({ isActive }) =>
                  isActive ? "sidebar-link active" : "sidebar-link"
                }>
                  <MessageSquareText
                    size={20}
                    fill="none"
                    color="#832865"
                    strokeWidth={1}
                  />
                  <p> کامنت های من</p>
                </NavLink>
              </div>
              <div>
                <NavLink to="change-password" className={({ isActive }) =>
                  isActive ? "sidebar-link active" : "sidebar-link"
                }>
                  <UserKey size={28} color="#832865" strokeWidth={1} />
                  <p> تغییر کلمه عبور</p>
                </NavLink>
              </div>
              <div>
                <NavLink to={logout} className="sidebar-logout-link">
                  <LogOut size={20} fill="none" color="#832865" strokeWidth={1} />
                  <p className="sidebar-logout-p"
                    onClick={async () => {

                      await logout();
                    }}
                  > خروج  </p>
                </NavLink>
              </div>

            </div>

          </div>
        </aside>
        <main></main>
      </div>

      <ScoreToWalletModal
        isOpen={scoreModalOpen}
        onClose={() => setScoreModalOpen(false)}
        user={{
          ...user,
          score,
          wallet_amount: walletAmount,
        }}
        onSuccess={({ walletAmount, score }) => {
          setWalletAmount(Number(walletAmount));
          setScore(Number(score));
        }}
      />


    </div>
  );
}
